import React, { useState } from 'react'
import styled from 'styled-components'
import theme from './theme'
import Icon from './Icon'

const ToggleContainer = styled.div`
    margin-bottom: 5px;
    
    .titleContainer{
      padding: 5px 0px;
      min-height: 26px;
      background-color: ${ theme.palette.light_grey };
      display:flex;
      justify-content: flex-start;
      align-items: center;
    }
    
    .titleContainer:hover{
      cursor:pointer;
    }
    
    .title{
      line-height: 16px;
      font-size: 14px;
      color: ${ theme.palette.black };
      margin-left: 20px;
    }
    
    .btn{
      text-align: right;
      flex-grow: 1;
      margin-right: 20px;
    }
    
    .content{
      margin-top: 10px;
      margin-left: 20px;
      margin-bottom: 10px;
      margin-right: 10px;
    }
    
    .img{
      position: relative;
      top: 2px;
    }
`

const ToggleItem = ({ title, content, onOpen }) => {
  const [display, setDisplay] = useState(false)

  const toggle = () => {
    setDisplay(!display)
    if(!display) {
      onOpen && onOpen()
    }
  }

  return (
    <ToggleContainer>
      <div className="titleContainer" onClick={ toggle }>
        <div className="title">{ title }</div>
        <div className="btn">
          { display ?
            <Icon className="img" name="chevron_up"/>
            : <Icon className="img" name="chevron_down"/> }</div>
      </div>
      { display && <div className="content" dangerouslySetInnerHTML={ { __html: content } }/> }
    </ToggleContainer>
  )
}

export default ToggleItem
